import React from 'react';
import styled from 'styled-components';
import {
  Col, Flex, Image, Row,
} from 'antd';
import { MailOutline } from '@mui/icons-material';
import { colors, fonts } from '../../assets/constStyles';
import { FooterSocial } from '../FooterSocial';
import { ChatButton } from '../button/ChatButton';
import { useResizeWidthWindow } from '../hook/useResizeWidthWindow';
import { ButtonStyled } from '../button/ButtonMainRed';

const DivStyled = styled.div`
  padding: 50px 50px 20px 50px;
  position: relative;

  && * {
    font-family: ${fonts.font2} !important;
  }

  @media (max-width: 768px) {
    padding: 20px;
  }
  
  .ant-input-outlined:hover,
  .ant-input-outlined:focus{
    border-color: ${colors.colorBackground}!important;
  }
  
  .ant-input-prefix{
    margin-right: 10px;
  }
`;
const IconStyled = styled(Image)`
  width: 300px;
  height: 70px;
  object-fit: cover;
`;

const H3Styled = styled.h3`
  color: ${colors.colorTextWhite};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 24px;
  font-family: ${fonts.font2};
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const PStyled = styled.p`
  color: ${colors.colorTextWhite};
  font-size: 18px;
  flex-grow: 1;
  font-family: ${fonts.font2};
`;

const DividerStyled = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  height: 0;
  margin-top: 20px;
`;

const DivAddressStyled = styled.div`
  margin-top: 20px;

  && * {
    font-size: 16px;
  }
`;

export const FooterMain: React.FC = () => (
    <div style={{ backgroundColor: colors.colorBackground, color: 'white' }}>
        <DivStyled>
            <Row gutter={[24, 24]}>
                <Col className="gutter-row" xs={13} sm={12} md={6} lg={6} xl={6}>
                    <Flex vertical align={'flex-start'} justify={'space-between'}>
                        <IconStyled src={'../img/logoBC-short-white.png'} preview={false} width={useResizeWidthWindow() > 700 ? 200 : 140}/>
                    </Flex>
                    <DivAddressStyled>
                        <Flex vertical>
                            <p>#101 - 4238 Lozells Avenue</p>
                            <p>Burnaby, BC, V5A 0C4</p>
                        </Flex>
                        <p style={{ padding: '10px 0' }}>(604) 298-3555</p>
                        <Flex align={'end'} gap={5}>
                            <MailOutline style={{ fontSize: 16 }}/>
                            <a href={'mailto:office@awmacbc.com'}>info.bc@awmac.com</a>
                        </Flex>

                    </DivAddressStyled>
                </Col>
                <Col className="gutter-row" xs={11} sm={12} md={7} lg={7} xl={7}>
                    <Flex vertical align={'flex-start'}>
                        <H3Styled>Connect</H3Styled>
                        <FooterSocial />
                    </Flex>
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={11} lg={11} xl={11}>
                    <Flex vertical align={'flex-start'}>
                        <H3Styled>Stay in touch</H3Styled>
                        <PStyled>To stay in the loop of the news, offerings, and industies tips, sign up for our Newsletter here! </PStyled>
                        <Flex gap={10} align={'center'} justify={'space-between'} style={{ marginTop: 20, width: '100%' }}>
                            {/* <FormNewsLetter /> */}
                            <a href={'https://awmac.us7.list-manage.com/subscribe?u=2d824269bbcb4dadacec713ae&id=026c449132'} target={'_blank'}>
                            <ButtonStyled size={'large'} aria-label={'Sign up'}>
                                Click Here To Sign up
                            </ButtonStyled>
                            </a>
                        </Flex>
                    </Flex>
                </Col>
            </Row>
            <ChatButton />
            <DividerStyled />
            <Row style={{ paddingTop: '20px' }}>
                <Flex justify={'space-between'} align={'center'} style={{ width: '100%' }}>
                    <p style={{ fontSize: useResizeWidthWindow() > 500 ? '1em' : '0.9em' }}>©Copyright {new Date().getFullYear()}  | Website designed and developed by Tetiana Hil</p>
                </Flex>
            </Row>
        </DivStyled>
    </div>);
